module.exports = __webpack_public_path__ + "static/media/general.618990d3.svg";